import { Box } from '@mui/material';
import { MediaInProgressLoader } from './MediaInProgressLoader';

interface MediaSkeletonLoaderOverlayProps {
  /** Export progress percent while the media asset is being generated. */
  progressPercent?: number;
}

/** Centers the in-progress loader over a relative-positioned media skeleton. */
export function MediaSkeletonLoaderOverlay({ progressPercent }: MediaSkeletonLoaderOverlayProps) {
  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <MediaInProgressLoader progressPercent={progressPercent} />
    </Box>
  );
}
